module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (options.preLocationsListText) { 
__p+='<span class="fmcy-pre-locations-list-text">'+
((__t=( options.preLocationsListText ))==null?'':__t)+
'</span>';
 } 
__p+='<ul class="fmcy-locations-container"></ul>';
 if (options.postLocationsListText) { 
__p+='<span class="fmcy-post-locations-list-text">'+
((__t=( options.postLocationsListText ))==null?'':__t)+
'</span>';
 } 
__p+='';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/available-at-locations/available-at-locations.html
 ** module id = 141
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 16 17 22 25 26 155
 **/